import { nb } from '@/i18n/nb';
import type { MapMode } from './mapTiles';
import s from './ModeToggle.module.css';

type ModeToggleProps = {
  mode: MapMode;
  onChange: (mode: MapMode) => void;
};

/*
 * Segmented control, bottom-centre. Three segments: Sjøkart (default) ↔ Topografisk
 * (both Kartverket), plus a visible-but-disabled Flyfoto segment with a "snart" badge —
 * the Norge-i-bilder service is deferred post-MVP (ADR-0010).
 *
 * `role="radiogroup"` with `role="radio"` children is the ARIA APG pattern for a
 * segmented control. Arrow keys + space activate, matching the toolbar pattern.
 */
export function ModeToggle({ mode, onChange }: ModeToggleProps) {
  return (
    <div className={s.toggle} role="radiogroup" aria-label="Kartlag">
      <button
        type="button"
        role="radio"
        aria-checked={mode === 'sjokart'}
        className={`${s.seg} ${mode === 'sjokart' ? s.on : ''}`}
        onClick={() => onChange('sjokart')}
      >
        {nb.map.modes.sjokart}
      </button>
      <button
        type="button"
        role="radio"
        aria-checked={mode === 'topo'}
        className={`${s.seg} ${mode === 'topo' ? s.on : ''}`}
        onClick={() => onChange('topo')}
      >
        {nb.map.modes.topo}
      </button>
      {/* Flyfoto is post-MVP: rendered, dimmed, disabled. The "snart" badge sets
          expectation; the disabled flag keeps a keyboard/SR user from selecting it. */}
      <button
        type="button"
        role="radio"
        aria-checked={false}
        aria-disabled="true"
        disabled
        className={`${s.seg} ${s.deferred}`}
        title="Kommer post-MVP"
      >
        {nb.map.modes.flyfoto}
        <span className={s.badge}>{nb.map.modes.flyfotoBadge}</span>
      </button>
    </div>
  );
}
